import {
  StatusLevel,
  StatusLevelData,
  StatusServiceModule,
  UpdateStatusServiceModuleData,
} from "../types/serviceModuleTypes";
import {
  CallResult,
  doApiDelete,
  doApiGet,
  doApiPatch,
  doApiPost,
  doApiPut,
} from "./Requests";

export const statusServiceModulesApi = {
  getStatusServiceModule: async (
    serviceModuleId: number
  ): Promise<CallResult<StatusServiceModule>> => {
    return await doApiGet<StatusServiceModule>(
      `/api/companies/current/servicemodules/statussystem/${serviceModuleId}/`
    );
  },

  updateStatusServiceModule: async (
    serviceModuleId: number,
    data: Partial<UpdateStatusServiceModuleData>
  ): Promise<CallResult<StatusServiceModule>> => {
    return await doApiPatch(
      `/api/companies/current/servicemodules/statussystem/${serviceModuleId}/`,
      data
    );
  },

  createStatusLevel: async (
    serviceModuleId: number,
    data: StatusLevelData
  ): Promise<CallResult<StatusLevel>> => {
    return await doApiPost(
      `/api/companies/current/servicemodules/statussystem/${serviceModuleId}/levels`,
      data
    );
  },

  updateStatusLevel: async (
    serviceModuleId: number,
    statusLevelId: string,
    data: StatusLevelData
  ): Promise<CallResult<StatusLevel>> => {
    return await doApiPut(
      `/api/companies/current/servicemodules/statussystem/${serviceModuleId}/levels/${statusLevelId}`,
      data
    );
  },

  deleteStatusLevel: async (
    serviceModuleId: number,
    statusLevelId: string
  ): Promise<CallResult<null>> => {
    return await doApiDelete(
      `/api/companies/current/servicemodules/statussystem/${serviceModuleId}/levels/${statusLevelId}`
    );
  },
};
